import React from 'react';
import{File,Folder,Download,Share2,Trash2,Star,RotateCcw}from'lucide-react';
import{theme,fileTypeColor}from'./theme';
import{formatBytes,fileExt,timeAgo}from'./api';
export function IconBtn({icon:Icon,onClick,title,size=14}){
  return<button onClick={onClick} title={title} style={{background:'none',border:'none',color:theme.textFaint,cursor:'pointer',display:'flex',padding:5,borderRadius:6}}
    onMouseEnter={e=>{e.currentTarget.style.color=theme.text;e.currentTarget.style.background=theme.bgHover;}}
    onMouseLeave={e=>{e.currentTarget.style.color=theme.textFaint;e.currentTarget.style.background='none';}}><Icon size={size}/></button>;
}
export function FileTypeIcon({fileName,isFolder,size=32}){
  if(isFolder)return<div style={{width:size,height:size,borderRadius:8,background:theme.accentBg,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}><Folder size={size*.5} color={theme.accent}/></div>;
  const ext=fileExt(fileName);const color=fileTypeColor(ext);
  return<div style={{width:size,height:size,borderRadius:8,background:`${color}1F`,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}><File size={size*.5} color={color}/></div>;
}
export function FileRow({item,onDownload,onDelete,onShare,onFavorite,onRestore,showRestore}){
  return<div style={{display:'flex',alignItems:'center',padding:'10px 16px',borderBottom:`1px solid ${theme.border}`,fontSize:13}}>
    <FileTypeIcon fileName={item.fileName} isFolder={item.isFolder} size={30}/>
    <div style={{flex:1,color:theme.text,marginLeft:12,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{item.fileName}</div>
    <div style={{width:90,color:theme.textFaint,fontSize:12.5}}>{item.isFolder?'—':formatBytes(item.fileSize)}</div>
    <div style={{width:110,color:theme.textFaint,fontSize:12.5}}>{timeAgo(item.updatedAt||item.createdAt)}</div>
    <div style={{display:'flex',gap:2,width:130,justifyContent:'flex-end'}}>
      {showRestore?<IconBtn icon={RotateCcw} title="Restore" onClick={()=>onRestore(item)}/>:<>
        {!item.isFolder&&<IconBtn icon={Star} title="Favorite" onClick={()=>onFavorite(item)}/>}
        {!item.isFolder&&<IconBtn icon={Download} title="Download" onClick={()=>onDownload(item)}/>}
        {!item.isFolder&&<IconBtn icon={Share2} title="Share" onClick={()=>onShare(item)}/>}
        <IconBtn icon={Trash2} title="Delete" onClick={()=>onDelete(item)}/>
      </>}
    </div>
  </div>;
}
export function FileListHeader(){
  return<div style={{display:'flex',padding:'9px 16px',background:theme.bgCard,fontSize:10.5,color:theme.textFaint,textTransform:'uppercase',letterSpacing:'0.05em',borderBottom:`1px solid ${theme.border}`}}>
    <div style={{width:30,marginRight:12}}/><div style={{flex:1}}>Name</div><div style={{width:90}}>Size</div><div style={{width:110}}>Modified</div><div style={{width:130}}/>
  </div>;
}
export function EmptyState({icon:Icon,label}){
  return<div style={{textAlign:'center',padding:'64px 20px'}}><Icon size={28} color={theme.textFaint} style={{opacity:.5}}/><p style={{color:theme.textFaint,fontSize:13,marginTop:12}}>{label}</p></div>;
}
export function ErrorBanner({message}){
  if(!message)return null;
  return<div style={{marginBottom:14,background:'rgba(226,75,74,0.1)',color:'#F09595',padding:'10px 14px',borderRadius:theme.radiusSm,fontSize:12.5}}>{message}</div>;
}
export function Card({children,style}){
  return<div style={{background:theme.bgCard,border:`1px solid ${theme.border}`,borderRadius:theme.radius,padding:16,...style}}>{children}</div>;
}
export function SectionTitle({children,action}){
  return<div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:12}}>
    <h3 style={{color:theme.text,fontSize:14,fontWeight:500,margin:0}}>{children}</h3>{action}
  </div>;
}
